import { useState } from 'react';
import { QueueLineModel, ShopperType } from '../types';

interface UseQueueLineStateReturn {
  isInQueueLineMode: boolean;
  setIsInQueueLineMode: React.Dispatch<React.SetStateAction<boolean>>;
  queueLines: QueueLineModel[];
  setQueueLines: React.Dispatch<React.SetStateAction<QueueLineModel[]>>;
  currentQueueLine: QueueLineModel | null;
  setCurrentQueueLine: React.Dispatch<
    React.SetStateAction<QueueLineModel | null>
  >;
  selectedShopperType: ShopperType;
  setSelectedShopperType: React.Dispatch<React.SetStateAction<ShopperType>>;
}

export const useQueueLineState = (): UseQueueLineStateReturn => {
  const [isInQueueLineMode, setIsInQueueLineMode] = useState<boolean>(false);
  const [queueLines, setQueueLines] = useState<QueueLineModel[]>([]);
  const [currentQueueLine, setCurrentQueueLine] =
    useState<QueueLineModel | null>(null);
  const [selectedShopperType, setSelectedShopperType] = useState<ShopperType>(
    ShopperType.WomanWithBasket
  );

  return {
    isInQueueLineMode,
    setIsInQueueLineMode,
    queueLines,
    setQueueLines,
    currentQueueLine,
    setCurrentQueueLine,
    selectedShopperType,
    setSelectedShopperType,
  };
};
